// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__Do8Ye","col":"styles_col__LJNrw"};